import { Icon } from 'src/components/atoms/Icon';
import Tile from 'src/components/DUP/atoms/Tile/Tile';
import ConnectedAccountsList from 'src/components/DUP/molecules/ConnectedAccountsList/ConnectedAccountsList';
import { useApplication } from 'src/context/ApplicationContext';
import { ARGYLE_HOW_TO_VIDEO_URL } from 'src/features/DUP';
import { useStepTranslations } from 'src/hooks/useClientTranslations';
import { generateButtonIdForTiles, generateTileDataAttributes } from 'src/utils/telemetry';
import { HowToLink } from './styles';

export const ConnectedPayrollTile = () => {
  const { tStep } = useStepTranslations();

  const {
    connectedPayroll: {
      openWidget,
      accountsConnected,
      isLoadingWidget: isLoading,
      disconnectAccount
    }
  } = useApplication();

  const buttonId = generateButtonIdForTiles('connected_payroll', 'start');

  const content = accountsConnected?.length ? (
    <ConnectedAccountsList
      connectedAccounts={accountsConnected}
      disconnectAccount={disconnectAccount}
    />
  ) : (
    [
      <>
        {tStep('connectPayrollTile.text.1')}
        <HowToLink href={ARGYLE_HOW_TO_VIDEO_URL} target="_blank" rel="noopener noreferrer">
          {tStep('learnMore')}
        </HowToLink>
      </>,
      tStep('connectPayrollTile.text.2')
    ]
  );

  return (
    <Tile
      title={tStep('connectPayrollTile.title')}
      subtitle={tStep('connectPayrollTile.subtitle')}
      icon={<Icon icon="check-recommended" />}
      button={{
        isLoading,
        isDisabled: isLoading,
        onClick: () => openWidget(),
        children: accountsConnected?.length
          ? tStep('connect.connectAdditionalAccounts')
          : undefined,
        telemetryId: buttonId
      }}
      content={content}
      telemetryDataAttributes={generateTileDataAttributes('proof_of_income', 'connected_payroll')}
    />
  );
};

export default ConnectedPayrollTile;
